import axios from "axios";
import { STORAGE_ACCESS_TOKEN } from "../config/index";
import timezone from "moment-timezone";

export const request = axios.create();

request.interceptors.request.use(
    config => {
        // const token = window.localStorage.getItem(STORAGE_ACCESS_TOKEN);
        // if (token && token.length > 10) {
        //     /* tslint:disable:no-string-literal */
        //     config.headers["Authorization"] = "Bearer " + token;
        // }
        config.headers['timezone'] = timezone.tz.guess()
        return config;
    },
);

request.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        if (error.response.status === 401) {
            // window.location.href = window.location.origin + window.location.pathname + "#/login"
            if (error.response.data.msg === "您已经在其他地方登录") {
                // message.info(error.response.data.msg)
            }
            return Promise.reject(error);
        }
        if (error.response.status === 404) {
            // message.error("连接不到服务器")
        }
        return Promise.reject(error);
    },
);
